export default __webpack_public_path__ + "static/media/momentjs.1d00b319.png";